import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import config from './config';

// Initialize Firebase with validated configuration
const app = initializeApp(config.firebase);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, config.functions.region);

// Connect to emulators if enabled and configured
if (config.emulators.enabled && !window._emulatorConfigured) {
  // Prevent multiple connections in React StrictMode
  window._emulatorConfigured = true;
  
  try {
    // Each emulator is optional — skip auth emulator to use real Google sign-in
    if (config.emulators.auth.url) {
      connectAuthEmulator(auth, config.emulators.auth.url, { disableWarnings: true });
      console.log('🔧 Auth emulator connected');
    }
    // Firestore emulator is optional — skip if not running to use production Firestore
    if (config.emulators.firestore.host && config.emulators.firestore.port) {
      try {
        connectFirestoreEmulator(
          db,
          config.emulators.firestore.host,
          config.emulators.firestore.port
        );
        console.log('🔧 Firestore emulator connected');
      } catch (e) {
        console.log('ℹ️ Firestore emulator not available, using production');
      }
    }
    if (config.emulators.functions.host && config.emulators.functions.port) {
      connectFunctionsEmulator(
        functions,
        config.emulators.functions.host,
        config.emulators.functions.port
      );
      console.log('🔧 Functions emulator connected');
    }
  } catch (error) {
    console.error('Failed to connect to emulators:', error);
  }
}

export default app;